
import { Vue, Component } from 'vue-property-decorator';

@Component
export default class ChatWidget extends Vue {
  private mounted() {
    this.init();
  }

  private beforeDestroy() {
    (window as any).webimInitialized = false;
    document.querySelectorAll('#webim-ico, .webim-root').forEach(el => {
      el.remove();
    });
  }

  private init() {
    (window as any).webim = {
      accountName: "onlinerby",
      domain: "onlinerby.webim.by",
      location: "moderaciya"
    };

    const s = document.createElement('script');

    s.type = 'text/javascript';
    s.async = true;
    s.src = 'https://onlinerby.webim.by/js/button.js';

    this.$el.append(s);
  }
}
